
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const common_base = namespace("common_base");
const user = namespace("user");

@Component({})
export default class MyCheckbox extends Vue {
  @Prop({ default: "", type: String })
  label: string;
  @Prop({ default: "", type: String })
  helpText: string;
  @Prop({ default: "parts", type: String })
  functionName: string;
  @common_base.State showPlatformParts;
  @common_base.State showPlatformServiceItem;
  @common_base.Mutation setShowPlatformParts;
  @common_base.Mutation setShowPlatformServiceItem;
  @user.State u8cStore;

  handleValueChange(val) {
    if (this.functionName === "parts") {
      this.setShowPlatformParts(val);
    } else if (this.functionName === "serviceItem") {
      this.setShowPlatformServiceItem(val);
    }
    this.$emit("change", val);
  }
}
